import { FC, useEffect } from 'react';
import TagManager from 'react-gtm-module';
import { VendorLogoBlock } from 'src/components';
import Arrow from 'src/images/icons/arrow-forward.svg?react';

type Props = {
  link: string;
  name: string;
  text: string;
  store: string;
  imageSrc?: string;
};

export const SubscriptionOffer: FC<Props> = ({ link, name, text, store, imageSrc }) => {
  useEffect(() => {
    TagManager.dataLayer({
      dataLayer: {
        event: 'Offer',
        eventCategory: 'engagement',
        eventLabel: `${name} Displayed`,
        eventValue: {
          offer_event: `${name} Displayed`,
          offer_name: name,
          store: store,
        },
      },
    });
  }, [name, store]);

  const handleClick = () => {
    TagManager.dataLayer({
      dataLayer: {
        event: 'Offer',
        eventCategory: 'engagement',
        eventLabel: `${name} Clicked`,
        eventValue: {
          offer_event: `${name} Clicked`,
          offer_name: name,
          store: store,
        },
      },
    });
  };

  return (
    <div className='bg-[#C3D4FF] transition-colors hover:bg-[#b3c5f3]'>
      <a
        href={link}
        target='_blank'
        rel='noopener noreferrer'
        onClick={handleClick}
        className='flex justify-center rounded-md py-1.5 text-sm text-[#2E4B93] md:py-2 lg:py-3'
      >
        <div className='mx-auto flex w-full max-w-[1440px] items-center justify-between gap-4 px-6 md:px-10 lg:px-12'>
          <div className='flex w-full flex-col items-end text-right'>
            <h6 className='font-primarytext-100 font-semibold text-[#2E4B93]'>{name}</h6>
            <p className='font-secondary text-xs text-[#2E4B93]'>{text}</p>
          </div>
          <VendorLogoBlock vendor={store} size={'medium'} customSrc={imageSrc} />
          <Arrow />
        </div>
      </a>
    </div>
  );
};
